// below rule can be safely turned off thanks to immer used by redux toolkit
/* eslint-disable no-param-reassign */

// Reducers can directly reassign state, or return a new state, BUT NOT BOTH
// Detailed docs on state reassignment in reducers here https://redux-toolkit.js.org/api/createreducer/
// There are pitfalls to immer however, which you can read here https://immerjs.github.io/immer/docs/pitfalls
import axios from 'supports/api';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  PO: [],
  countPO: 0,
  branches: [],
  tujuanPengeluaran: [],
  status: 'idle',
  error: null,
};

const { actions, reducer } = createSlice({
  name: 'purchaseOrder',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    fetchTujuanPengeluaranSuccess: (state, action) => {
      state.status = 'success';
      state.tujuanPengeluaran = action.payload;
    },
    fetchBranchesSuccess: (state, action) => {
      state.status = 'success';
      state.branches = action.payload;
    },
    fetchPoSuccess: (state, action) => {
      state.status = 'success';
      state.PO = action.payload.rows;
      state.countPO = action.payload.count;
    },
    fetchFailure: (state, action) => {
      state.status = 'failure';
      state.error = action.payload;
    },
  },
});

export default reducer;

export const {
  fetchStart,
  fetchTujuanPengeluaranSuccess,
  fetchPoSuccess,
  fetchFailure,
  fetchBranchesSuccess,
} = actions;

export const fetchTujuanPengeluaran = () => async (dispatch) => {
  dispatch(fetchStart());
  try {
    const { data } = await axios.get(`/masterTujuanPengeluaran/getAll`);
    dispatch(fetchTujuanPengeluaranSuccess(data.result));
  } catch (err) {
    dispatch(fetchFailure(err));
  }
};

export const fetchBranches = () => async (dispatch) => {
  dispatch(fetchStart());
  try {
    const { data } = await axios.get(`/branch/all`);
    dispatch(fetchBranchesSuccess(data.result));
  } catch (err) {
    dispatch(fetchFailure(err));
  }
};

/**
 * Loads one page of PO rows into `PO` / `countPO`. `endpoint` and `body`
 * come from the tab config in pages/finance/purchaseOrder/config.js.
 */
export const fetchPoRows = (endpoint, body) => async (dispatch) => {
  dispatch(fetchStart());
  try {
    const { data } = await axios.post(endpoint, body);
    dispatch(fetchPoSuccess(data.result));
  } catch (err) {
    // eslint-disable-next-line no-alert
    alert(err.message);
    dispatch(fetchFailure(err));
  }
};
